<template>
  
  <vx-card no-shadow>
    <h2 class="mb-6">Contact</h2>
    <Loading v-if="loading" />
    <div v-else class="vx-row mb-6" v-for="(role, idx) in contactRoles" :key="idx">
      <div class="vx-col sm:w-1/5 w-full">
        <span><strong>{{ contactRolesMap[idx] }}</strong></span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <p
          v-for="user in contactUsers.filter((e) => e.userRole === role)"
          :key="user.userId"
        >
          {{ user.firstName }} {{ user.lastName }} - {{ user.email }} -
          {{ user.phoneCountryCode }}{{ user.phone }}
        </p>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},

  data() {
    return {loading: false,};
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      contactUsers: "venues/contactUsers",
      contactRoles: "venues/contactRoles",
      contactRolesMap: "venues/contactRolesMap"
    }),
  },
  methods: {},
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("venues/getContactUsers");
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.con-chips--remove-all {
  display: none;
}
</style>